// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1O6NH","paramInput":"JobSimulator_paramInput__3XhqW","input":"JobSimulator_input__u9pHk"};